/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { InfoFlag } from '../index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default InfoFlag;
